import type {NavigationGuardReturn, RouteLocationNormalized} from 'vue-router';
import ResourceRepository from '@/api/repositories/ResourceRepository';
import {useToast} from '@/shared/components/toast/useToast';
import {translate} from '@/shared/mixins/translation';

export async function handleLegacyQrCode(
    to: RouteLocationNormalized
): Promise<NavigationGuardReturn> {
    const seatId = to.params.seatId;

    if (!seatId) {
        return {name: 'Home'};
    }

    try {
        // resolve the old resource ID
        const resourceCheck = await ResourceRepository().check(seatId);
        return {
            name: 'BookingMap',
            params: {roomId: resourceCheck.resource.room},
            query: {resourceId: resourceCheck.resource.id},
        };
    } catch {
        useToast().error(translate('app.errors.qr_code_outdated'));
        return {name: 'Home'};
    }
}
